export default __webpack_public_path__ + "static/media/Results-Graph_TextureYellow-simple.25879174.svg";